import moment from "moment";
import { FormValidationRule } from "../../forms/types";

const isExcluded: FormValidationRule = (c, v) => {
    let valid = true;
    let message = "";

    if (c.excluded_dates && v) {
        const value = moment(v, "YYYY-MM-DD").format("DD/MM/YYYY");
        const excludedDates = c.excluded_dates.split(",");

        if (excludedDates.includes(value)) {
            valid = false;
            message = "Please enter an allowed date.";
        }
    }
    return [valid, message];
};

export default isExcluded;
